import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useKioskoStore} from 'context/kiosko/useKioskoStore';
import {useErrorModal} from '@chekin/shared';

function KioskoErrorModal() {
  const {displayError, ErrorModal} = useErrorModal();
  const {t} = useTranslation('kiosko');
  const errorStatus = useKioskoStore(state => state.scanner.error);

  useEffect(() => {
    if (errorStatus) {
      displayError({title: t('error'), message: t(errorStatus)});
    }
  }, [errorStatus, displayError, t]);
  return <ErrorModal title={t('error')} />;
}

export {KioskoErrorModal};
